import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "fields-group-determinant",
  templateUrl: "./fields-group-determinant.component.html",
})
export class FieldsGroupDeterminantComponent {

  @Input() public group: any;
  @Input() public determinants: any[] = [];
  @Input() public depth: number = 1;

  @Output() public onRelationChange: EventEmitter<any> = new EventEmitter();

  public toggleClass(event: any, cssclass: string) {
    const elem = event.target;
    const parent = elem.closest(".group-toggle");
    parent.classList.toggle(cssclass);
  }

  public onGroupClick(event = null): void {
    this.onRelationChange.emit(event ? event : this.group);
  }

  public haveDeterminant(determinantId: string): boolean {
    let exists: boolean = false;
    if (this.group.determinants && this.group.determinants.length) {
      this.group.determinants.forEach((determinant: any) => {
        if (determinant.id === determinantId) {
          exists = true;
        }
      });
    }
    if (this.group.components && this.group.components.length) {
      this.group.components.forEach((component: any) => {
        const have: boolean = this.haveGroupDeterminant(component, determinantId);
        if (have) {
          exists = true;
        }
      });
    }
    return exists;
  }

  private haveGroupDeterminant(group: any, determinantId: string): boolean {
    let exists: boolean = false;
    if (group.determinants && group.determinants.length) {
      group.determinants.forEach((determinant: any) => {
        if (determinant.id === determinantId) {
          exists = true;
        }
      });
    }
    if (group.components && group.components.length) {
      group.components.forEach((component: any) => {
        const have: boolean = this.haveGroupDeterminant(component, determinantId);
        if (have) {
          exists = true;
        }
      });
    }
    return exists;
  }

}
